package ru.notamedia.qah.web

object LocalStorage {

    fun save(key: String, value: String) {
        ru.notamedia.qah.web.save(key, value)
    }

    fun get(key: String): String {
        return ru.notamedia.qah.web.get(key)
    }
}

expect fun save(key: String, value: String)
expect fun get(key: String): String